import { useEffect, useRef, useState } from "react";
import { Modal } from "@mui/material";
import styled from "styled-components";
import ButtonComponent from "../button";
import IconCheck from "../../assets/images/icon-check-2.svg"
import IconFail from "../../assets/images/icon-fail.svg"
import L from 'leaflet';
import { onSleep } from "../../utils/default";
import InputComponent from "../evaluation-form-components/input";
import DropdownComponent from "../evaluation-form-components/dropdown";

let map;
let pin;

const Container = styled.div`
    width: calc(480px - 72px);
    /* height: calc(324px - 48px); */
    max-height: calc(100vh - 160px);
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .image {
        margin-bottom: 24px;
    }

    .header-label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 24px;
    }

    .header-sub-label {
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: center;
        white-space: pre-line;
        margin-bottom: 24px;
    }

    .button-container {
        margin-top: auto;
        margin-bottom: 0px;

        .button-box {
            width: 200px;
        }
    }

    .input-box {

    }
`;

const MapX = styled.div`
    width: 100%;
    height: 360px;
    border-radius: 10px;
`;

function LocationCreateModal({
    open,
    detailData,
    listProvince,
    styleContainer,
    onConfirm,
    onClose,
}) {
    const [title, setTitle] = useState("");
    const [mapPosition, setMapPosition] = useState({
        latitude: 13.75398,
        longitude: 100.50144,
    })
    const [zoomMap, setZoomMap] = useState(6);
    const [information, setInformation] = useState({
        location_id: null,
        location_name: null,
        province: null,
        latitude: null,
        longitude: null,
    });
    const [informationError, setInformationError] = useState({
        location_name: false,
        province: false,
        latitude: false,
        longitude: false,
    });
    const informationRef = useRef({
        location_id: null,
        location_name: null,
        province: null,
        latitude: null,
        longitude: null,
    });
    const informationErrorRef = useRef({
        location_name: false,
        province: false,
        latitude: false,
        longitude: false,
    });

    useEffect(() => {
        const func = async () => {
            if (open) {
                onInit(detailData);
                await InitMap();
                let detail = { ...information };
                detail.latitude = detailData?.latitude
                detail.longitude = detailData?.longitude
                setPinMap(detail.latitude, detail.longitude);
            }
        }
        func();
    }, [open, detailData])

    async function onInit(param) {
        let _isEdit = false;
        if (param?.location_id) {
            _isEdit = true;
        }
        setTitle(_isEdit ? "แก้ไขสถานที่" : "สร้างสถานที่")
        informationRef.current.location_id = param?.location_id;
        informationRef.current.location_name = param?.location_name;
        informationRef.current.province = param?.province;
        setInformation({
            ...informationRef.current,
        })
    }
    async function InitMap() {
        try {
            await onSleep(1000);
            map = L.map(`map`, {
                center: [mapPosition.latitude, mapPosition.longitude],
                zoom: zoomMap,
            })
            //==============================
            const tileLayer = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            const tiles = L.tileLayer(tileLayer, {
                maxZoom: 19,
                minZoom: 5,
            });
            tiles.addTo(map);
            //==============================
            map.zoomControl.setPosition('bottomright');
            //==============================
            await SetMapEvent();
            //==============================
        } catch (e) { }
    }
    async function SetMapEvent() {
        if (!map) return;

        map.on("click", (e) => {
            let latlng = e.latlng;
            let lat = latlng.lat;
            let lon = latlng.lng;
            setPinMap(lat, lon);
        });
    }
    function setPinMap(lat, lon) {
        if (!map) return;
        if (!lat || !lon) return;
        // ========== ========== ========== ==========
        if (pin) {
            map.removeLayer(pin);
        }
        const coodinate = [Number(lat), Number(lon)];

        let marker = L.marker(coodinate, { draggable: true });
        let svgPin =
            '<div class="marker-bounce">' +
            '<svg width="30px" height="40px" viewBox="0 0 485.213 485.212">' +
            '<path fill="#E03528" d=""/>' +
            '<path fill="#E03528" d="M242.606,0C142.124,0,60.651,81.473,60.651,181.955s151.631,303.257,181.956,303.257' +
            "c30.326,0,181.955-202.775,181.955-303.257S343.089,0,242.606,0z M242.606,303.257c-66.9,0-121.302-54.433-121.302-121.302" +
            'S175.706,60.651,242.606,60.651c66.902,0,121.302,54.435,121.302,121.304S309.509,303.257,242.606,303.257z"/>' +
            "</svg>" +
            "</div>";

        const icon = L.divIcon({
            html: svgPin,
            className: "icon",
            iconAnchor: [15, 30],
            popupAnchor: [9, -25],
        });

        marker.options.icon = icon;

        pin = marker;
        pin.on("dragend", (e) => {
            const newCoords = e.target.getLatLng();
            const pinCoordinates = [newCoords.lat, newCoords.lng];
            map.setView(pinCoordinates);
            informationRef.current.latitude = pinCoordinates[0];
            informationRef.current.longitude = pinCoordinates[1];
            setInformation({
                ...informationRef.current,
            })
        });
        map.addLayer(pin);

        // const zoomCurrent = map.getZoom();
        // const zoomLevel = zoomCurrent > 15 ? zoomCurrent : 15;
        // map.setView(coodinate, zoomLevel);
        map.setView(coodinate);
        informationRef.current.latitude = coodinate[0];
        informationRef.current.longitude = coodinate[1];
        setInformation({
            ...informationRef.current,
        })
    }
    function validateLatLong(str, type) {
        let regex = /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
        if (type === "longitude") {
            regex = /^-?((\d|[1-9]\d|1[0-7]\d)(\.\d+)?|180(\.0+)?)$/
        }
        const check = regex.test(str);
        return check;
    }
    function checkValidateInput() {
        let check = false;
        let errorInput = {
            ...informationError,
        }
        if (!(information.location_name?.trim())) {
            check = true;
            errorInput.location_name = true;
        }
        if (!information.province) {
            check = true;
            errorInput.province = true;
        }
        if (information.latitude && information.longitude) {
            const checkLat = validateLatLong(
                information.latitude,
                "latitude"
            );
            const checkLong = validateLatLong(
                information.longitude,
                "longitude"
            );
            if (!checkLat) {
                check = true;
                errorInput.latitude = true;
            }
            if (!checkLong) {
                check = true;
                errorInput.longitude = true;
            }
        }
        if (!information.latitude) {
            check = true;
            errorInput.latitude = true;
        }
        if (!information.longitude) {
            check = true;
            errorInput.longitude = true;
        }
        setInformationError(errorInput)
        return check;
    }
    function clearAllData() {
        if (map) {
            if (pin) {
                map.removeLayer(pin);
            }
            map.setView([mapPosition.latitude, mapPosition.longitude], zoomMap);
        }
        let detail = {
            ...information,
            location_name: null,
            province: null,
            latitude: null,
            longitude: null,
        }
        let errorInput = {
            ...informationError,
            location_name: false,
            province: false,
            latitude: false,
            longitude: false,
        }
        setInformation({ ...detail })
        informationRef.current = { ...detail }
        setInformationError({ ...errorInput })
        informationErrorRef.current = { ...errorInput }
    }

    function handleConfirm() {
        const check = checkValidateInput();
        if (check) return;
        let _detail = {
            latitude: null,
            longitude: null,
        };
        if (information) {
            _detail = { ...information };
            _detail.latitude = _detail.latitude ? Number(_detail.latitude) : null;
            _detail.longitude = _detail.longitude ? Number(_detail.longitude) : null;
        }
        onConfirm && onConfirm(_detail);
        clearAllData();
    }
    function handleClose() {
        clearAllData();
        onClose && onClose();
    }
    function handleChangeInformation(key, value) {
        let detail = {
            ...information,
        }
        detail[key] = value;
        setInformation(detail)
        informationRef.current = { ...detail }
        let errorInput = {
            ...informationError,
        }
        errorInput[key] = false;
        setInformationError(errorInput)
        informationErrorRef.current = { ...errorInput }
    }
    function handlePasteInformation(param, key) {
        param.preventDefault();
        const pastedData = param.clipboardData.getData("text");
        const splitData = pastedData?.split(",");
        let detail = {
            ...information,
        }
        let errorInput = {
            ...informationError,
        }
        if (splitData.length > 1) {
            const latitude = Number(splitData[0]);
            const longitude = Number(splitData[1]);
            if (!isNaN(latitude)) {
                detail.latitude = latitude;
                errorInput.latitude = false;
            }
            if (!isNaN(longitude)) {
                detail.longitude = longitude;
                errorInput.longitude = false;
            }
        } else {
            const value = Number(pastedData);
            if (!isNaN(value)) {
                detail[key] = value;
                errorInput[key] = false;
            }
        }
        setInformation(detail)
        informationRef.current = { ...detail }
        setInformationError(errorInput)
        informationErrorRef.current = { ...errorInput }
        handleEnterInformation();
    }
    function handleEnterInformation() {
        let errorInput = {
            ...informationError
        }
        if (informationRef.current.latitude && informationRef.current.longitude) {
            const checkLat = validateLatLong(informationRef.current.latitude, "latitude");
            const checkLong = validateLatLong(informationRef.current.longitude, "longitude");
            if (checkLat && checkLong) {
                setPinMap(informationRef.current.latitude, informationRef.current.longitude);
            } else if (!checkLat) {
                errorInput.latitude = true;
            } else if (!checkLong) {
                errorInput.longitude = true;
            }
        } else if (informationRef.current.latitude) {
            const checkLat = validateLatLong(informationRef.current.latitude, "latitude");
            if (!checkLat) {
                errorInput.latitude = true;
            }
        } else if (informationRef.current.longitude) {
            const checkLong = validateLatLong(informationRef.current.longitude, "longitude");
            if (!checkLong) {
                errorInput.longitude = true;
            }
        }
        setInformationError(errorInput)
        informationErrorRef.current = { ...errorInput }
    }
    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <Container
                style={{ ...styleContainer }}
            >
                <div className="header-label">{title}</div>

                <div className="vertical-center">
                    <InputComponent
                        placeholder={"ชื่อสถานที่"}
                        styleInput={{ border: "1px solid #B5B5B5", width: "calc(100% - 32px)", padding: "0px 16px 0px 16px" }}
                        value={information.location_name}
                        isError={informationError.location_name}
                        onInput={(e) => { handleChangeInformation("location_name", e) }}
                    />
                </div>
                <div className="vertical-center">
                    <DropdownComponent
                        placeholder={"เลือกจังหวัด"}
                        styleDropdownItemBox={{ zIndex: 500 }}
                        list={listProvince}
                        value={{ id: information.province }}
                        isError={informationError.province}
                        onSelect={(e) => { handleChangeInformation("province", e?.id) }}
                    />
                </div>

                {open && <MapX id={`map`} />}

                <div className="vertical-center" style={{ gap: "16px", marginTop: "24px" }}>
                    <InputComponent
                        label={"ละติจูด"}
                        placeholder={"ละติจูด"}
                        styleInput={{ border: "1px solid #B5B5B5", width: "calc(100% - 32px)", padding: "0px 16px 0px 16px" }}
                        value={information.latitude}
                        isError={informationError.latitude}
                        type={"number"}
                        onInput={(e) => { handleChangeInformation("latitude", e) }}
                        onPaste={(e) => { handlePasteInformation(e, "latitude") }}
                        onEnter={handleEnterInformation}
                        onBlur={handleEnterInformation}
                    />
                    <InputComponent
                        label={"ลองจิจูด"}
                        placeholder={"ลองจิจูด"}
                        styleInput={{ border: "1px solid #B5B5B5", width: "calc(100% - 32px)", padding: "0px 16px 0px 16px" }}
                        value={information.longitude}
                        isError={informationError.longitude}
                        type={"number"}
                        onInput={(e) => { handleChangeInformation("longitude", e) }}
                        onPaste={(e) => { handlePasteInformation(e, "longitude") }}
                        onEnter={handleEnterInformation}
                        onBlur={handleEnterInformation}
                    />
                </div>

                <div className="button-container horizontal-center" style={{ gap: "16px" }}>
                    <div className="button-box">
                        <ButtonComponent
                            label={"ปิด"}
                            variant={"secondary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleClose}
                        />
                    </div>
                    <div className="button-box">
                        <ButtonComponent
                            label={"ยืนยัน"}
                            variant={"primary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleConfirm}
                        />
                    </div>
                </div>
            </Container>
        </Modal>
    )
}

export default LocationCreateModal;